'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { Tab, TabList, TabPanel, Tabs } from 'react-aria-components';
import ReviewsCarousel from '@/features/reviews/components/reviews-carousel/reviews-carousel';
import { REVIEWS } from '@/features/reviews/constants/reviews-constants';
import styles from './reviews.module.scss';
export default function Reviews() {
  const $ = _c(27);
  const reviewsTranslates = useTranslations("page.reviews");
  let t0;
  if ($[0] !== reviewsTranslates) {
    t0 = reviewsTranslates("room-reviews");
    $[0] = reviewsTranslates;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <Tab id="rooms-reviews" className={styles.reviewsTabs_tab}>{t0}</Tab>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== reviewsTranslates) {
    t2 = reviewsTranslates("apartment-reviews");
    $[4] = reviewsTranslates;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t2) {
    t3 = <Tab id="apartment-reviews" className={styles.reviewsTabs_tab}>{t2}</Tab>;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== reviewsTranslates) {
    t4 = reviewsTranslates("roommate-reviews");
    $[8] = reviewsTranslates;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t4) {
    t5 = <Tab id="roommate-reviews" className={styles.reviewsTabs_tab}>{t4}</Tab>;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== reviewsTranslates) {
    t6 = reviewsTranslates("tenant-reviews");
    $[12] = reviewsTranslates;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t6) {
    t7 = <Tab id="tenants-reviews" className={styles.reviewsTabs_tab}>{t6}</Tab>;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t1 || $[17] !== t3 || $[18] !== t5 || $[19] !== t7) {
    t8 = <TabList className={styles.reviewsTabs_tabList} aria-label="Roomster reviews">{t1}{t3}{t5}{t7}</TabList>;
    $[16] = t1;
    $[17] = t3;
    $[18] = t5;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <TabPanel id="rooms-reviews" className={styles.reviewsTabs_tabPanel}><ReviewsCarousel reviews={REVIEWS.rooms} /></TabPanel>;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <TabPanel id="apartment-reviews" className={styles.reviewsTabs_tabPanel}><ReviewsCarousel reviews={REVIEWS.apartments} /></TabPanel>;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <TabPanel id="roommate-reviews" className={styles.reviewsTabs_tabPanel}><ReviewsCarousel reviews={REVIEWS.roommate} /></TabPanel>;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <TabPanel id="tenants-reviews" className={styles.reviewsTabs_tabPanel}><ReviewsCarousel reviews={REVIEWS.tenants} /></TabPanel>;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t8) {
    t13 = <Tabs className={styles.reviewsTabs}>{t8}{t9}{t10}{t11}{t12}</Tabs>;
    $[25] = t8;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  return t13;
}